import { atom, atomFamily } from 'recoil';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomstructureset';
import { StructureSet } from '~/domain/patient/structureset';

export const currentStructureSetState = atom<StructureSet | undefined>({
    key: 'currentStructureSetState',
    default: undefined,
    dangerouslyAllowMutability: true,
});

export type StructureSetState = {
    sopUid: string;
    structureSetLabel: string;
    structureSetDescription: string;
    approvalStatus: DICOMApprovalStatus;
    reviewerName: string;
    reviewDate: string;
    reviewTime: string;
    visible: boolean;
    manufacturer: string;
    manufacturerModelName: string;
    softwareVersions: string;
    numberOfStructures: number;
};

export const structureSetState = atomFamily<StructureSetState, string>({
    key: 'structureSetState',
    default: undefined,
});
